import { render, staticRenderFns } from "./realEstateDevelopmentDiagnosisResult.vue?vue&type=template&id=3ba04904&scoped=true"
import script from "./realEstateDevelopmentDiagnosisResult.vue?vue&type=script&lang=js"
export * from "./realEstateDevelopmentDiagnosisResult.vue?vue&type=script&lang=js"
import style0 from "./realEstateDevelopmentDiagnosisResult.vue?vue&type=style&index=0&id=3ba04904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba04904",
  null
  
)

export default component.exports